import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom';
import { HeaderIcon } from '../utils/header-icon';
import { HeaderLogo } from '../utils/header-logo';
import { HeaderMenu } from '../utils/header-menu';
import { MenuInformasiLainnya, MenuInformasi, MenuProfile, MenuAduan } from 'master-data/menu';
import { FiChevronDown } from "react-icons/fi";
export const Header = () => {

	const [OpenMobileMenu, setOpenMobileMenu] = useState('');
	const [SubMenuProfile, setSubMenuProfile] = useState('');
	const [SubMenuInformasi, setSubMenuInformasi] = useState('');
	const [SubMenuInformasiLainnya, setSubMenuInformasiLainnya] = useState('');
	const [SubMenuAduan, setSubMenuAduan] = useState('');

	function handleOpenMobileMenu() {
		if (OpenMobileMenu === 'jl_mobile_nav_open') {
			setOpenMobileMenu('')
		} else {
			setOpenMobileMenu('jl_mobile_nav_open')
		}
	}

	function getCurrentDate() {
        var today = new Date();
        return today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ' PM'
    }

	function handleSubProfil() {
		if (SubMenuProfile === 'menu-active-class') {
			setSubMenuProfile('')
		} else {
			setSubMenuProfile('menu-active-class')
		}
	}
	
	function handleSubInformasi() {
		if (SubMenuInformasi === 'menu-active-class') {
			setSubMenuInformasi('')
		} else {
			setSubMenuInformasi('menu-active-class')
		}
	}

	function handleSubInformasiLainnya() {
		if (SubMenuInformasiLainnya === 'menu-active-class') {
			setSubMenuInformasiLainnya('')
		} else {
			setSubMenuInformasiLainnya('menu-active-class')
		}
	}

	function handleSubAduan() {
		if (SubMenuAduan === 'menu-active-class') {
			setSubMenuAduan('')
		} else {
			setSubMenuAduan('menu-active-class')
		}
	}

    return (
		<Fragment>
        <header className="header-wraper jl_header_magazine_style two_header_top_style header_layout_style3_custom jl_cus_top_share">
			<div className="jl_blank_nav" style={{height: '81px'}} ></div>
			<div id="menu_wrapper" className="menu_wrapper jl_menu_sticky jl_stick jl_sticky">
				<div className="container">
					<div className="row">
						<div className="main_menu col-md-12">
							<div className="search_header_menu jl_nav_mobile">
								<div className="menu_mobile_icons">
									<div onClick={() => handleOpenMobileMenu()} className="jlm_w"><span className="jlma" /><span className="jlmb" /><span className="jlmc" /></div>
								</div>
								<div className="search_header_wrapper search_form_menu_personal_click"><i className="jli-search" /></div>
							</div>
							<div className="menu-primary-container navigation_wrapper jl_cus_share_mnu">
								<HeaderMenu />
							</div>
						</div>
					</div>
				</div>
			</div>
      </header>
	  <div id="content_nav" className={`jl_mobile_nav_wrapper ` + OpenMobileMenu}>
          {/* <div id="content_nav" className="jl_mobile_nav_wrapper jl_mobile_nav_open"> */}
        <div id="nav" className="jl_mobile_nav_inner">
          <div onClick={() => handleOpenMobileMenu()} className="menu_mobile_icons mobile_close_icons closed_menu">
            <span className="jl_close_wapper"><span className="jl_close_1" /><span className="jl_close_2" /></span>
          </div>
        <ul id="mobile_menu_slide" className="menu_moble_slide">
		  	<li className="menu-item current-menu-item current_page_item">
                <Link to={'/home'}>
                    Home
                    <span className="border-menu" />
                </Link>
            </li>
			<li className="menu-item menu-item-has-children">
                <a onClick={() => handleSubProfil()} href="#void">
                    Profil
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className={`sub-menu ` + SubMenuProfile}>
                    {
                        MenuProfile && MenuProfile.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item menu-item-has-children">
                <a onClick={() => handleSubInformasi()} href="#void">
                    Informasi
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className={`sub-menu ` + SubMenuInformasi}>
                    {
                        MenuInformasi && MenuInformasi.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item menu-item-has-children">
				<a onClick={() => handleSubInformasiLainnya()} href="#void">
                    Informasi Lainnya
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className={`sub-menu ` + SubMenuInformasiLainnya}>
                    {
                        MenuInformasiLainnya && MenuInformasiLainnya.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/infografis'}>
                    Infografis
                    <span className="border-menu" />
                </Link>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/download'}>
                    Download
                    <span className="border-menu" />
                </Link>
            </li>

            <li className="menu-item menu-item-has-children">
				<a onClick={() => handleSubAduan()} href="#void">
                    Aduan
                    <span className="border-menu" />
                    <FiChevronDown className='navbar-head-icon' />
                </a>
                <ul className={`sub-menu ` + SubMenuAduan}>
                    {
                        MenuAduan && MenuAduan.map((item, index) => {
                            return (
                                <li key={index} className="menu-item">
                                    <Link to={item.link}>
                                        {item.name}
                                        <span className="border-menu" />
                                    </Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </li>

            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/kritik-dan-saran'}>
                    Kritik dan Saran
                    <span className="border-menu" />
                </Link>
            </li>
            <li className="menu-item current-menu-item current_page_item">
                <Link to={'/survey-kepuasan-masyarakat'}>
                    Survey
                    <span className="border-menu" />
                </Link>
            </li>
          </ul>
        </div>
      </div>
	  </Fragment>
    )
};